import React, { useState, useEffect } from 'react'

const DigitalMarketing = () => {
    const [activeService, setActiveService] = useState('seo');

    useEffect(() => {
        // Add click event listeners to service tabs
        const tabs = document.querySelectorAll('.service-tab');
        const details = document.querySelectorAll('.service-detail');

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const service = tab.getAttribute('data-service');

                // Remove active class from all tabs and details
                tabs.forEach(t => t.classList.remove('active'));
                details.forEach(d => d.classList.remove('active'));

                // Add active class to clicked tab and corresponding detail
                tab.classList.add('active');
                document.getElementById(service).classList.add('active');

                setActiveService(service);
            });
        });
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                {/* <div className="breadcrumb-tagline">
                                    <span className="breadcrumb-line"></span>
                                    <span className="breadcrumb-text">AMPLIFY YOUR BRAND REACH</span>
                                </div> */}
                                <h1 className="breadcrumb-title">
                                    Digital <span className="breadcrumb-highlight">Marketing</span>
                                </h1>
                                <button className="breadcrumb-btn">
                                    <span>CONNECT NOW</span>
                                    <span className="breadcrumb-arrow">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>

            {/* Digital Marketing Overview Section */}
            <section className="ai-driven-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="ai-driven-content">
                                <h2 className="ai-driven-title" style={{ textAlign: 'left' }}>
                                    <span className="text-gradient">Strategic Digital Marketing </span> Services
                                </h2>
                                <p className="ai-driven-description">
                                    In the competitive digital landscape, effective marketing strategies are crucial for business growth and brand visibility. CLOUD MIND X delivers data-driven digital marketing solutions that amplify your online presence, engage target audiences, and drive measurable results. From SEO to social media, we create comprehensive campaigns that transform your brand into a market leader.
                                </p>
                                <button className="ai-driven-btn">
                                    <span>TALK TO AN EXPERT</span>
                                    <span className="ai-driven-arrow">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="ai-driven-image-wrapper">
                                <img
                                    src="https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?w=800&q=80"
                                    alt="Digital Marketing Services"
                                    className="ai-driven-image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* How We Help Section */}
            <section className="how-we-help-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-header text-center mb-5">
                                <span className="section-tagline">OUR EXPERTISE</span>
                                <h2 className="section-title" style={{ textAlign: 'center' }}>How We Help</h2>
                                <p className="text-muted lead m-0">
                                    With proven expertise in digital marketing and a team of 50+ marketing specialists,<br />
                                    <span className="text-gradient">CLOUD MIND X</span> provides comprehensive marketing services to help businesses<br />
                                    grow their online presence, reach target audiences, and achieve sustainable growth.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row align-items-start">
                        {/* Left Side - Services Menu */}
                        <div className="col-lg-5">
                            <div className="services-menu">
                                <div className="service-tab active" data-service="seo">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">SEO Services</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="ppc">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">PPC & Paid Advertising</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="social-media">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Social Media Marketing</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="content">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Content Marketing</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="email">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Email Marketing</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="analytics">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Analytics & Reporting</h3>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Service Details */}
                        <div className="col-lg-7">
                            <div className="service-details-container">
                                {/* SEO Services */}
                                <div className="service-detail active" id="seo">
                                    <h3 className="service-detail-title">SEO Services</h3>
                                    <p className="service-detail-description">
                                        Dominate search engine rankings with comprehensive SEO strategies that drive organic traffic and increase visibility. We perform in-depth keyword research, technical SEO audits, on-page optimization, link building, and local SEO to ensure your website ranks higher, attracts quality leads, and establishes authority in your industry.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request SEO Services</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* PPC & Paid Advertising */}
                                <div className="service-detail" id="ppc">
                                    <h3 className="service-detail-title">PPC & Paid Advertising</h3>
                                    <p className="service-detail-description">
                                        Generate immediate results with targeted pay-per-click campaigns across Google Ads, Bing Ads, and social media platforms. Our PPC experts create high-converting ad campaigns, optimize bidding strategies, conduct A/B testing, and manage budgets to maximize ROI while minimizing cost-per-acquisition and driving qualified traffic.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request PPC Services</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Social Media Marketing */}
                                <div className="service-detail" id="social-media">
                                    <h3 className="service-detail-title">Social Media Marketing</h3>
                                    <p className="service-detail-description">
                                        Build engaged communities and amplify your brand presence across Facebook, Instagram, LinkedIn, Twitter, and TikTok. We develop creative content strategies, manage social media campaigns, engage with your audience, run targeted ads, and leverage influencer partnerships to increase brand awareness and foster customer loyalty.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Social Media Services</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Content Marketing */}
                                <div className="service-detail" id="content">
                                    <h3 className="service-detail-title">Content Marketing</h3>
                                    <p className="service-detail-description">
                                        Attract and nurture your audience with compelling content that educates, entertains, and converts. We create blogs, articles, infographics, videos, whitepapers, and case studies that establish thought leadership, improve SEO, drive traffic, and guide prospects through the buyer's journey with valuable, engaging narratives.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Content Marketing</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Email Marketing */}
                                <div className="service-detail" id="email">
                                    <h3 className="service-detail-title">Email Marketing</h3>
                                    <p className="service-detail-description">
                                        Nurture leads and drive conversions with personalized email campaigns that deliver results. We design responsive email templates, segment audiences, create automated workflows, conduct A/B testing, and optimize deliverability to ensure your messages reach the right people at the right time with compelling calls-to-action.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Email Marketing</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Analytics & Reporting */}
                                <div className="service-detail" id="analytics">
                                    <h3 className="service-detail-title">Analytics & Reporting</h3>
                                    <p className="service-detail-description">
                                        Make informed decisions with comprehensive analytics and transparent reporting. We track KPIs, analyze user behavior, measure campaign performance, and provide actionable insights through custom dashboards and detailed reports. Our data-driven approach ensures continuous optimization and demonstrates clear ROI for all marketing initiatives.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Analytics Services</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Digital Marketing Capabilities Section */}
            <section className="ai-capabilities-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-header text-center mb-5">
                                <span className="section-tagline-white">MARKETING EXCELLENCE</span>
                                <h2 className="section-title-dark">Digital Marketing Channels & Strategies We Master</h2>
                                <p className="section-description-dark">
                                    CLOUD MIND X leverages cutting-edge marketing tools, platforms, and strategies to deliver measurable results across all digital channels. Our expertise spans <strong>multi-channel campaigns, growth hacking, and conversion optimization</strong> across industries including SaaS, e-commerce, healthcare, real estate, finance, hospitality, and B2B services.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        {/* Search Engine Marketing */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="20" cy="20" r="10" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M28 28L38 38" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <circle cx="20" cy="20" r="5" fill="#4187f7" opacity="0.3" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Search Engine Marketing</h4>
                                <p className="capability-description">
                                    Dominate search results with comprehensive SEM strategies combining organic and paid tactics. We optimize for Google, Bing, and other search engines using advanced keyword targeting, ad extensions, remarketing campaigns, and conversion tracking to ensure maximum visibility and qualified traffic at optimal costs.
                                </p>
                            </div>
                        </div>

                        {/* Social Media Advertising */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="24" cy="24" r="16" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M24 16C24 16 20 20 20 24C20 28 24 32 24 32C24 32 28 28 28 24C28 20 24 16 24 16Z" fill="#4187f7" opacity="0.3" />
                                        <circle cx="24" cy="24" r="3" fill="#4187f7" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Social Media Advertising</h4>
                                <p className="capability-description">
                                    Reach your target audience with precision-targeted social media ads across all major platforms. We create engaging ad creatives, define audience segments, optimize bidding strategies, and leverage advanced features like lookalike audiences, custom conversions, and dynamic retargeting to maximize engagement and conversions.
                                </p>
                            </div>
                        </div>

                        {/* Conversion Rate Optimization */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10 32L16 24L22 28L30 16L38 22" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <circle cx="38" cy="22" r="3" fill="#4187f7" />
                                        <path d="M32 10H38V16" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Conversion Rate Optimization</h4>
                                <p className="capability-description">
                                    Transform visitors into customers with data-driven CRO strategies. We conduct comprehensive audits, implement A/B testing, optimize landing pages, improve user experience, refine calls-to-action, and streamline conversion funnels to maximize your ROI and dramatically increase conversion rates across all touchpoints.
                                </p>
                            </div>
                        </div>

                        {/* Influencer Marketing */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="24" cy="18" r="6" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M12 38C12 32 17 28 24 28C31 28 36 32 36 38" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M24 12L26 16H30L27 19L28 23L24 20L20 23L21 19L18 16H22L24 12Z" fill="#4187f7" opacity="0.3" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Influencer Marketing</h4>
                                <p className="capability-description">
                                    Amplify your brand reach through strategic influencer partnerships and collaborations. We identify relevant influencers, negotiate partnerships, manage campaigns, and track performance to ensure authentic brand advocacy that resonates with your target audience and drives engagement, trust, and measurable business results.
                                </p>
                            </div>
                        </div>

                        {/* Video Marketing */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="8" y="12" width="32" height="24" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M20 18L30 24L20 30V18Z" fill="#4187f7" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Video Marketing</h4>
                                <p className="capability-description">
                                    Captivate audiences with compelling video content optimized for YouTube, social media, and your website. We produce engaging video ads, explainer videos, product demonstrations, testimonials, and live streams that tell your brand story, increase engagement, and drive conversions across all video platforms.
                                </p>
                            </div>
                        </div>

                        {/* Marketing Automation */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="10" y="10" width="28" height="28" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M18 20H30M18 24H30M18 28H24" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <circle cx="34" cy="14" r="4" fill="#4187f7" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Marketing Automation</h4>
                                <p className="capability-description">
                                    Streamline and scale your marketing efforts with sophisticated automation platforms. We implement HubSpot, Marketo, Mailchimp, and other tools to automate lead nurturing, email sequences, social posting, and customer journeys, ensuring timely, personalized communication that drives conversions while saving time and resources.
                                </p>
                            </div>
                        </div>

                        {/* Brand Strategy */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 8L30 20H40L32 28L36 40L24 32L12 40L16 28L8 20H18L24 8Z" stroke="#4187f7" strokeWidth="2" strokeLinejoin="round" />
                                        <path d="M24 8L30 20H40L32 28L36 40L24 32L12 40L16 28L8 20H18L24 8Z" fill="#4187f7" opacity="0.2" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Brand Strategy & Positioning</h4>
                                <p className="capability-description">
                                    Build a powerful brand identity that resonates with your target market and stands out from competitors. We develop comprehensive brand strategies, define unique value propositions, create brand guidelines, and implement consistent messaging across all channels to establish strong brand recognition and customer loyalty.
                                </p>
                            </div>
                        </div>

                        {/* Reputation Management */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="24" cy="24" r="16" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M24 16V24L30 28" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M16 12L18 16M32 12L30 16M12 16L16 20M36 16L32 20" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Online Reputation Management</h4>
                                <p className="capability-description">
                                    Protect and enhance your brand's online reputation with proactive monitoring and management. We track mentions, reviews, and social conversations, respond to feedback, address negative content, promote positive testimonials, and implement strategies to build trust, credibility, and a stellar online reputation.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default DigitalMarketing
